import config from './config.js'

export default {

  saveDocument(doc) {
    return fetch(config.baseUrl + 'rest/cms/documents',{ method: 'POST', credentials: 'include', body: JSON.stringify(doc)}).then(resp => resp.json());
  },

  loadDocument(id) {
    return fetch(config.baseUrl + 'rest/cms/documents/' + encodeURIComponent(id),{ credentials: 'include' }).then(resp => resp.json());
  },

  deleteDocument(id) {
    return fetch(config.baseUrl + 'rest/cms/documents/' + encodeURIComponent(id), {credentials:'include',method:'DELETE'}).then(resp => resp.json());
  },

  list(cat,tree,start,count) {
    var cid = encodeURIComponent(cat);
    var tid = encodeURIComponent(tree);
    return fetch(config.baseUrl + 'rest/cms/documents?catID=' + cid + '&tree=' + tid + '&start=' + start + '&count=' + count,{credentials: 'include'}).then(resp => resp.json());
  },

  listResources(area,type) {
    return fetch(config.baseUrl + 'rest/cms/resources/' + encodeURIComponent(area) + '/' + encodeURIComponent(type),{credentials: 'include'}).then(resp => resp.json());
  },

  getResource(area,type,name) {
    return fetch(config.baseUrl + 'rest/cms/resources/' + encodeURIComponent(area) + '/' + encodeURIComponent(type) + '/' + encodeURIComponent(name), { credentials: 'include' }).then(resp => resp.text());
  },

  uploadResource(area,type,name,content) {
    return fetch(
      config.baseUrl + 'rest/cms/resources/' + encodeURIComponent(area) + '/' + encodeURIComponent(type) + '/' + encodeURIComponent(name),
      {
        method: 'POST',
        body: content,
        credentials: 'include'
      }
    ).then(resp => resp.json());
  },

  deleteResource(area,type,name) {
    return fetch(
      config.baseUrl + 'rest/cms/resources/' + encodeURIComponent(area) + '/' + encodeURIComponent(type) + '/' + encodeURIComponent(name),
      {
        method: 'DELETE',
        credentials: 'include'
      }
    ).then(resp => resp.json());
  },

  listhtmlcomponents(tree) {
    return fetch('/trendshop.proxy.web/rest/cms/htmlcomponents/' + encodeURIComponent(tree)).then(resp => resp.json());
  }
}
